import { usePaymentTransactionHistoryList } from '@/api/gen'
import { DataTable } from '@/components/data-table'
import { tableQueryState } from '@/components/table-query-state'
import { useAuth } from '@/hooks/use-auth'
import { useAuditHistoryTableCols } from '@/pages/rewards/hooks/use-audit-history-table-cols'

import { HISTORY_QUERY_OPTIONS, PAGE_SIZE_OPTIONS } from './constants'
import { useHistoryPagination } from './use-history-pagination'

export const TransactionsHistoryTable = () => {
  const columns = useAuditHistoryTableCols()
  const { isAuthorized, isInitialized } = useAuth()
  const { pagination, onPaginationChange, params } = useHistoryPagination()

  const { data, error, isError, isFetching, refetch } = usePaymentTransactionHistoryList(params, {
    query: { ...HISTORY_QUERY_OPTIONS, enabled: isAuthorized },
  })

  return (
    <DataTable
      manualPagination
      columns={columns}
      data={data?.results ?? []}
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      pagination={pagination}
      rowCount={data?.count ?? 0}
      onPaginationChange={onPaginationChange}
      {...tableQueryState({
        error,
        hasData: data !== undefined,
        isError,
        isFetching,
        isInitialized,
        refetch,
      })}
      getRowId={(_row, index) => String(index)}
    />
  )
}
